// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

//  Components
import { Container, Row, Col } from 'reactstrap';
import Button from 'components/atoms/Button';

// Constants
import { HOME_ROUTE } from 'constants/routes';

import './DeleteAccount.scss';
import SidebarContext from 'components/pages/User/Sidebar/SidebarContext';

type Props = {
  close: () => void,
  closeProfileModal: () => void,
  generateTokenId: () => void,
  goTo: string => void,
  deleteAccount: () => any,
  intl: IntlShape
};

type State = {
  isSubmitting: boolean
};

class DeleteAccount extends React.Component<Props, State> {
  static block = 'delete-account';

  state = {
    isSubmitting: false
  };

  async onDeleteAccount(toggleSidebar: (isOpen: boolean) => void) {
    const {
      deleteAccount,
      close,
      closeProfileModal,
      goTo,
      generateTokenId
    } = this.props;
    this.setState({
      isSubmitting: true
    });
    const { data } = await deleteAccount();
    this.setState({
      isSubmitting: false
    });
    if (data && data.success) {
      close();
      closeProfileModal();
      toggleSidebar(false);
      generateTokenId();
      goTo(HOME_ROUTE);
    }
  }

  render() {
    const ns = DeleteAccount.block;
    const { close, intl } = this.props;
    const { isSubmitting } = this.state;
    return (
      <SidebarContext.Consumer>
        {({ toggleSidebar }) => {
          return (
            <Container className={ns}>
              <Row>
                <Col className={`${ns}__card d-flex flex-column`}>
                  <h1
                    className={`${ns}__title align-self-md-center mb-md-2 mb-lg-4 pt-lg-5`}
                  >
                    {intl.formatMessage({ id: 'c8.delete.account.title' })}
                  </h1>
                  <div className={`${ns}__subtitle`}>
                    {intl.formatMessage({
                      id:
                        'c8.delete.account.are.you.sure.you.want.to.delete.the.account'
                    })}
                  </div>
                  <div className={`d-flex flex-column`}>
                    <Button
                      className={`${ns}__delete-account-button`}
                      onClick={() => {
                        this.onDeleteAccount(toggleSidebar);
                      }}
                    >
                      {intl.formatMessage({
                        id: 'c8.delete.account.yes.delete.my.account'
                      })}
                      {isSubmitting && (
                        <div className="ld ld-ring ld-spin-fast" />
                      )}
                    </Button>
                    <Button buttonTheme="link" onClick={() => close()}>
                      {intl.formatMessage({ id: 'c8.common.cancel' })}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          );
        }}
      </SidebarContext.Consumer>
    );
  }
}

export default DeleteAccount;



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/DeleteAccount/DeleteAccount.js